import { Outlet } from 'react-router-dom';
import { Sidebar } from '@/components/layout/Sidebar';
import { Header } from '@/components/layout/Header';
import { CommandPalette } from '@/components/layout/CommandPalette';
import { NotificationCenter } from '@/components/layout/NotificationCenter';
import { Toaster } from '@/components/ui/Toast';
import { useWsConnection } from '@/hooks/useRealTimeData';

export function AppLayout() {
  useWsConnection();
  return (
    <div className="flex h-screen overflow-hidden bg-base-bg">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
      <CommandPalette />
      <NotificationCenter />
      <Toaster />
    </div>
  );
}
